jQuery(document).ready(function ($) {
  //################################################################//
  //######*****   PO Checker
  //################################################################//



  //Add error div
  $('<div class="po-error-message text-penketh_red text-15"></div>').insertAfter('#pk_customer_purchase_order_number_field').show("fast")

  if ($("#po_mask_helper_hidden_field input").val() != "") {
    $poValue = $("#po_mask_helper_hidden_field input").val();

    $(
      "<p class='text-15 po-value-helper pb-2'>" + $poValue + "</p>"
    ).insertAfter("#pk_customer_purchase_order_number_field > label");
  }

  //character limit check
  $("#pk_customer_purchase_order_number").on('keyup',function(event) {      
    var maxLength = $( this ).attr( "maxlength" );
    var curLength = $( this ).val().length;
	  var fieldError = ".po-error-message";
  
    if (maxLength <= curLength)  
    {    
        var curLength = $( this ).val().length; 
        $(fieldError).text("This field has a maximum of 60 characters");
        $( this ).val($( this ).val().substring(0, maxLength-1));
    }else {
        $(this).css('background','none');
        $(fieldError).text("");
    }       		
});


});
